import {useSelector} from 'react-redux';

/**
 * The current company's name.
 * @returns {string|undefined}
 */
export const useCompanyName = () => useSelector(state => state.company?.name);
